import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_6: FaireProductEntity = {
  token: "atc_updated_fs_rec_6",
  type: "product",
  name: "Geometric Block Table Lamps Set",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/fb410e81add79aa0ca4b11a563f7e5ae639d843b677e8207acaebea408acbb83.webp",
  priceDollars: 89,
  msrpDollars: 120,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
